<template>
    <div class="contenido">
        <div class="access-denied">
            <img width="100px" height="100px" src="/img/sol_tdoriente.svg" alt="">
            <h2 class="blinking-text">Acceso Denegado</h2>
            <p>No tienes permiso para visualizar o utilizar este recurso.</p>
        </div>
    </div>
</template>
<script>
export default {
  props: {
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods:{
  },
}
</script>
<style scoped>
    .contenido {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        background-color: #f8d7da;
        font-family: Arial, sans-serif;
        margin: 0;
    }
    .access-denied {
        background: #721c24;
        color: white;
        padding: 20px;
        border-radius: 10px;
        text-align: center;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
        transform: scale(0.5);
        animation: fadeInScale 0.5s ease-in-out forwards;
    }
    @keyframes fadeInScale {
        from {
            opacity: 0;
            transform: scale(0.5);
        }
        to {
            opacity: 1;
            transform: scale(1);
        }
    }
    @keyframes blinkText {
        0% { color: white; }
        50% { color: red; }
        100% { color: white; }
    }
    .blinking-text {
        animation: blinkText 1s infinite;
    }
    .icon {
        font-size: 50px;
        margin-bottom: 10px;
    }
</style>
